import {
  Button,
  CustomRewardBalance,
  CustomRewardCurrency,
  JoonUIColor,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useRewardQuantityModal } from "./RewardQuantityModal"

type Props = { rewardBalance: CustomRewardBalance }

const RewardRedeemButton = ({ rewardBalance }: Props) => {
  const { onOpen: onOpenQuantityModal } = useRewardQuantityModal()
  const { t } = useTranslation()

  const onRedeemClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onOpenQuantityModal(rewardBalance)
  }

  return (
    <Button
      buttonType="secondary"
      size="small"
      onClick={onRedeemClick}
      text={
        <Typography variant="bodySmall" color={JoonUIColor.text.primary}>
          {rewardBalance.reward.currency === CustomRewardCurrency.MINUTE
            ? t("REWARD_APPROVE")
            : t("REWARD_USE")}
        </Typography>
      }
      style={{
        borderRadius: SPACING.space2,
        border: `1px solid ${JoonUIColor.border.default}`,
        padding: `${SPACING.space1} ${SPACING.space2}`,
      }}
    />
  )
}

export default RewardRedeemButton
